import { render, staticRenderFns } from "./news-box.vue?vue&type=template&id=121e256a&scoped=true"
import script from "./news-box.vue?vue&type=script&lang=js"
export * from "./news-box.vue?vue&type=script&lang=js"
import style0 from "./news-box.vue?vue&type=style&index=0&id=121e256a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121e256a",
  null
  
)

export default component.exports